import { ProductStore } from "./ProductStore";
import { CategoryStore } from "./CategoryStore";
import { FeaturedStore } from "./FeaturedStore";

import { Preferences } from '@capacitor/preferences';

var url = `${process.env.REACT_APP_BASE_URL}`;

export const fetchData = async () => {

    /*
    const json = ["beds.json", "armchairs.json", "coffee_tables.json", "cushions.json", "floor_lamps.json", "office_chairs.json"];

    var products = [];

    json.forEach( async category => {

        const products = await fetchProducts(category);

        let categoryName = category.replace(".json", "");
        categoryName = categoryName.replace("_", " ");
        categoryName = uppercaseWords(categoryName);

        const productCategory = {

            name: categoryName,
            slug: category.replace(".json", ""),
            cover: products[6].image,
            products
        };

        ProductStore.update(s => { s.products = [ ...s.products, productCategory ]; });
    });

    return products;
    */

    var products = [];

    const response = await fetch(url + '/api/categories');

    if (response.status === 429) {
        alert("Please slow down, too many requests. Please wait a few seconds and try again.");
        return;
    }

    const json = await response.json();

    CategoryStore.update(s => { s.categories = json.data; s.hasLoaded = true; });

    // Use map to create an array of promises
    const productPromises = json.data.map(async category => {
        const products = await fetchProducts(category.name);

        let categoryName = uppercaseWords(category.description);

        /*
        const productCategory = {
            name: categoryName,
            slug: category.name,
            cover: category.name + '.png',
            products
        };
        */

        ProductStore.update(s => { s.hasLoaded = true; });
    });

    // Use Promise.all to wait for all the promises to resolve
    await Promise.all(productPromises);

    ProductStore.update(s => { s.fullyLoaded = true; });

    // Suggest products based on recent searches. Limit to 10 products
    await Preferences.get({ key: 'recentSearches' }).then((res) => {
        if (res.value) {
            const recentSearches = JSON.parse(res.value);
            const suggestProducts = [];

            // Flatten the products array from all categories
            const allProducts = ProductStore.getRawState().products.flatMap(category =>
                category.products.map(product => ({
                    ...product,
                    category_name: category.slug, // For URLs and routing
                    category_display_name: category.name // For display purposes
                }))
            );
            // Keep track of the total number of suggestions
            let totalSuggestions = 0;

            // Loop through all products
            for (const product of allProducts) {
                if (totalSuggestions >= 15) {
                    break; // Stop if we already have 10 suggestions
                }

                // Check if the product matches any recent search
                const isMatch = recentSearches.some(search => {
                    const productName = product.name.toLowerCase();
                    const searchName = search?.name?.toLowerCase();
                    return productName.includes(searchName);
                });

                // If it's a match and not already in the suggestions, add it
                if (isMatch && !suggestProducts.some(p => p.id === product.id)) {
                    suggestProducts.push(product);
                    totalSuggestions++;
                }
            }

            // Update the ProductStore with the suggested products
            ProductStore.update(s => {
                s.suggestProducts = suggestProducts; // Limit to 10 products
            });
        }
    });

    await fetchFeatured();

    return products;
}

let rateLimitAlertShown = false;
const fetchProducts = async (category, page = 1) => {
    var data = [];

    const response = await fetch(`${url}/api/categoryInventory?category=${category}&page=${page}`);

    if (response.status === 429) {
        if (!rateLimitAlertShown) {
            alert("Please slow down, too many requests. Please wait a few seconds and try again.");
            rateLimitAlertShown = true;
        }
        return [];
    }

    const json = await response.json();

    if (json.hasOwnProperty('data')) {
        data = json.data.data;

        // Update the ProductStore with the new products
        ProductStore.update(s => {
            let categoryIndex = s.products.findIndex(cat => cat.slug === category);
            // If the category does not exist, create it
            if (categoryIndex === -1) {
                s.products.push({
                    slug: category,
                    name: uppercaseWords(category), // Ensure the name is set
                    cover: `${category}.png`, // Set a default cover image
                    products: [],
                    currentPage: 1,
                    totalProducts: 0,
                    pagination: {}
                });
                categoryIndex = s.products.length - 1; // Update the index to the newly added category
            }

            // Update the category's products and pagination
            s.products[categoryIndex].products = [
                ...s.products[categoryIndex].products,
                ...data
            ];
            s.products[categoryIndex].currentPage = page; // Update the current page
            s.products[categoryIndex].totalProducts = json.data.total; // Update the total products
            s.products[categoryIndex].pagination = {
                to: json.data.to,
                total: json.data.total,
                current_page: json.data.current_page,
                per_page: json.data.per_page,
                last_page: json.data.last_page
            };
        });
    }

    return data; // Ensure the fetched data is returned
}

export const fetchMoreProducts = async (category, currentPage) => {
    const nextPage = currentPage + 1;

    // Fetch the next page of products
    const newProducts = await fetchProducts(category, nextPage);

    if (newProducts.length > 0) {
        // Update the current page in the store or state
        ProductStore.update(s => {
            let categoryIndex = s.products.findIndex(cat => cat.slug === category);

            // If the category does not exist, create it
            if (categoryIndex === -1) {
                s.products.push({
                    slug: category,
                    products: [],
                    currentPage: 1,
                    totalProducts: 0,
                    pagination: {}
                });
                categoryIndex = s.products.length - 1; // Update the index to the newly added category
            }

            // Update the current page
            s.products[categoryIndex].currentPage = nextPage;
        });
    }
};

const uppercaseWords = words => {

    words = words.toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');

    return words;
}

export const fetchFeatured = async (page = null) => {

    var res = [];

    const json = await fetch(url + '/api/sponsored/' + (page ? '?page=' + page : ''))
        .then(response => response.json())
        .then(async response => {
            FeaturedStore.update(s => {
                s.products = [...s.products, ...response.data]; // Append new products
                s.hasLoaded = true;
                s.pagination = {
                    to: response.to,
                    total: response.total,
                    current_page: response.current_page,
                    per_page: response.per_page,
                    last_page: response.last_page
                };
            });
            res = response.data;
            //FeaturedStore.update(s => {s.products = response.data; s.hasLoaded= true;});
        });

    return res;
}